export const processStatus = {
  Init: 'init',
  Progress: 'progress',
  Ready: 'ready',
  Fail: 'fail',
}
